<script setup lang="ts">
const route = useRoute();
const { data } = await useKirbyData(route.path, {
  transform: (page: Record<string, any>) => slimPagePayload(page),
});
requirePageData(data.value);
setPage(data.value);
useArticleJsonLd(computed(() => data.value), () => route.path);

useHead({
  bodyAttrs: {
    class: `article-page`,
  },
});
definePageMeta({
  layout: "default",
});
</script>

<template>
  <div>
    <AppHeading1 />
    <AppHeroImage />
    <div class="content-wrapper">
      <div class="content content-article">
        <div class="article-text">
          <h2>{{ data?.title }}</h2>
          <p class="date">{{ data?.published }}</p>
          <KirbyLayouts v-if="data?.layouts" :layouts="data?.layouts ?? []" />
          <div v-html="data?.text" />
          <template v-for="(item, index) in data?.builder" :key="index">
            <div v-html="item.text" />
          </template>
          <AppAuthor />
        </div>

        <section id="moreArticles">
          <h2>More Articles</h2>
          <AppMoreNewsArticlesList />
        </section>
      </div>
    </div>
  </div>
</template>
